<template>
    <div @click="driveClicked()">
        <slot></slot>
    </div>
</template>

<script>
    import FormDataStore from "../stores/FormDataStore";

    export default {
        name: "GDriveSelector",
        props: {
            filesChange: Function,
        },
        data() {
            return {
                pickerApiLoaded: false,
                credentials: FormDataStore.data.credentials.gdrive,
                scope: "https://www.googleapis.com/auth/drive.readonly",
            };
        },
        mounted() {
            const gDrive = document.createElement("script");
            gDrive.setAttribute("type", "text/javascript");
            gDrive.setAttribute("src", "https://apis.google.com/js/api.js");
            document.head.appendChild(gDrive);
        },
        methods: {
            async driveClicked() {
                await gapi.load("auth2", () => {
                    gapi.auth2.authorize(
                        {
                            client_id: this.credentials.client_id,
                            scope: this.scope,
                            immediate: false
                        },
                        this.handleAuthResult
                    );
                });
            },

            handleAuthResult(authResult) {
                if (authResult && !authResult.error) {
                    this.credentials.access_token = authResult.access_token;
                    gapi.load("picker", () => {
                        this.pickerApiLoaded = true;
                        this.createPicker();
                    });
                }
            },

            // Create and render a Picker object for picking user Photos.
            createPicker() {
                if (this.pickerApiLoaded && this.credentials.access_token) {
                    const view = new google.picker.View(google.picker.ViewId.DOCS);
                    view.setMimeTypes("image/png,image/jpeg,image/jpg,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword");
                    const picker = new google.picker.PickerBuilder()
                        .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
                        .addView(view)
                        .setOAuthToken(this.credentials.access_token)
                        .setDeveloperKey(this.credentials.api_key)
                        .setCallback(this.pickerCallback)
                        .build();
                    picker.setVisible(true);
                }
            },
            async pickerCallback(data) {
                if (data[google.picker.Response.ACTION] === google.picker.Action.PICKED) {
                    this.filesChange(data.docs);
                }
                this.pickerApiLoaded = false;
            },
        },
    };
</script>

